import { IDtrUsageMetadata }        from '@app/modules/usage/config/dtr-usage.config';
import { IGkUsageMetadata }         from '@app/modules/usage/config/gk-usage.config';
import { IAdminUsageTabItemConfig } from '@app/modules/usage/presets/usage-base-config.model';
import { AllowedDetailsTabEnum }    from '@core/interfaces/common.interfaces';
import {
	UsageDtrScopesEnum,
	UsageGkScopesEnum
}                                   from '@models/scope.enums';

// ENUMS #############################################################
// API enums *********************************************************
// UI enums **********************************************************
// usage

export enum UsagePresetEnum {
	ACCOUNT_FISKAL = 'accountFiskal',
	ADMIN_CONSOLE_DTR_VOLUME = 'adminConsoleDtrVolume',
	ADMIN_CONSOLE_GK_ARCHIVE = 'adminConsoleGkArchive',
	ADMIN_CONSOLE_GK_CLOUD = 'adminConsoleGkCloud',
	ADMIN_CONSOLE_GK_TOKEN = 'adminConsoleGkToken',
	BUSINESS_PREMISES_FISKAL = 'businessPremisesFiskal',
	CURRENT_TENANT_FISKAL = 'currentTenantFiskal',
	CONTRACT_ARCHIVING = 'contractArchiving',
	CONTRACT_ELSTER = 'contractElster',
	CONTRACT_FISKAL = 'contractFiskal',
	MY_ACCOUNT_CONTRACT_ARCHIVING = 'myAccountContractArchiving',
	MY_ACCOUNT_CONTRACT_ELSTER = 'myAccountContractElster',
	MY_ACCOUNT_CONTRACT_FISKAL = 'myAccountContractFiskal',
	ORGANIZATION_FISKAL = 'organizationFiskal',
	TASK_CENTER_DATA_INTEGRITY_ERRORS = 'taskCenterDataIntegrityErrors',
	TASK_CENTER_FCC_OPEN_TRANSACTIONS = 'taskCenterFccOpenTransactions',
	TASK_CENTER_FCC_VERSIONS = 'taskCenterFccVersions'
}

export enum UsageTypeEnum {
	DTR = 'dtr',
	ENTITY = 'entity',
	GK = 'gk'
}

export enum UsageModelEnum {
	ARCHIVE = 'archive',
	BUSINESS_PREMISES = 'businessPremises',
	CLOUD = 'cloud',
	CURRENT_TENANT = 'currentTenant',
	CONTRACT = 'contract',
	FCC_OPEN_TRANSACTIONS = 'fccOpenTransactions',
	FCC_VERSION = 'fccVersion',
	ORGANIZATION = 'organization',
	TENANT = 'tenant',
	TOKEN = 'token',
	USAGE = 'usage',
	VOLUME = 'volume',
}

export enum UsagePeriodTypeEnum {
	YEAR = 'year',
	YEAR_MONTH = 'yearMonth',
	YEAR_MONTH_DAY = 'yearMonthDay'
}

// INTERFACES ########################################################
// API interfaces ****************************************************

// UI interfaces *****************************************************
export interface IUsagePeriod {
	date?: Date;
	type: UsagePeriodTypeEnum;
}

export type AdminUsageMetadata = IDtrUsageMetadata | IGkUsageMetadata;

export type AdminUsageScopeType = UsageDtrScopesEnum | UsageGkScopesEnum;

export interface IAllowedTabMap {
	usage: UsageModelEnum;
	allowed: AllowedDetailsTabEnum;
}

export interface IAdminUsageMetadata {
	entityId: string;
	storeId: {
		usages: string;
	};
	i18n: {
		basepath: string;
		page: string;
		report: string;
		usageItems: string;
	};
	checkReportStatusTimer: number;

	tabItemsConfigs: IAdminUsageTabItemConfig[];
	allowedTabMap: IAllowedTabMap[];
}
